import React from "react"
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SnowEffect from '../components/SnowEffect';

const NotFound = () => {
    const navigate = useNavigate();
    
    return (
        <Box sx={{ minHeight: '100vh', bgcolor: '#E3F2FD', position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {/* Snow Effect */}
            <SnowEffect />
            
            <Container maxWidth="md" sx={{ textAlign: 'center', position: 'relative', zIndex: 2 }}>
                <Typography variant="h1" component="h1" sx={{ fontWeight: 700, mb: 2, color: 'primary.main' }}>
                    404
                </Typography>
                <Typography variant="h4" component="h2" gutterBottom sx={{ mb: 2 }}>
                    Page Not Found
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                    Sorry, the page you are looking for does not exist.
                </Typography>
                <Button 
                    variant="contained" 
                    size="large"
                    onClick={() => navigate('/')}
                    sx={{ px: 4, py: 1.5 }}
                >
                    Go Home
                </Button>
            </Container>
        </Box>
    )
}

export default NotFound